module.exports = __webpack_public_path__ + "img/photo_2020-11-16_15-03-19 2.c0d71459.png";